import styled from '@emotion/styled';

import { Black, Grey, Primary, Secondary } from '../../styles/Colors';
import { FontSize, FontWeight } from '../../styles/Typography';

export const StyledHeader = styled.header`
  position: relative;
  background-color: ${Black};
  height: 3.375rem;
  border-bottom: 1px solid ${Grey[500]};

  .connection-status {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: ${FontSize['Sm']};
    color: ${Secondary[50]};
  }

  ul {
    display: flex;
    justify-content: center;
    height: 3.375rem;

    li {
      line-height: normal;
      font-size: ${FontSize['2Xl']};
      align-items: center;
      display: inline-flex;
      margin-right: 3.125rem;
      font-weight: ${FontWeight['SemiBold']};

      a {
        text-decoration: none;
        color: ${Grey[200]};
      }
    }

    li:last-child {
      margin-right: 0;
    }

    li.selected {
      border-bottom: 1px solid ${Primary[300]};

      a {
        color: ${Primary[300]};
      }
    }
  }
`;
